export default __webpack_public_path__ + "static/media/Microsoft_logo_(2012) (1).fad6368e.svg";